import { AppAlert } from '@components/antd';
import { useAppBanner } from './hooks/use-app-banner';
import { DowngradePlanModal } from '@modules/settings/subscription/components/downgrade-plan-cancel-modal';
import { useScheduledDowngrade } from './hooks/use-scheduled-downgrade';
import { useTranslation } from 'react-i18next';

export const ScheduledDowngradeBanner = () => {
  const { t } = useTranslation();
  const { formattedDate, workspaceSubscription } = useAppBanner();
  const { handleOpen, open, handleClose, handleDowngradeCancelled, downgradeLoading } = useScheduledDowngrade({
    workspaceSubscriptionId: workspaceSubscription?.id,
  });
  const scheduledPlanItem = workspaceSubscription?.scheduledChanges?.subscriptionItems?.find(
    (item) => item?.itemType === 'plan'
  );
  const scheduledPlanPriceId = scheduledPlanItem?.itemPriceId;
  const scheduledPlanKey = scheduledPlanPriceId?.split('-')?.[2];
  const scheduledPlan = scheduledPlanKey === 'basic' ? 'standard' : (scheduledPlanKey ?? '');
  const scheduledBillingPeriod = workspaceSubscription?.scheduledChanges?.billingPeriodUnit?.startsWith('year')
    ? 'Yearly'
    : 'Monthly';

  const downgradePlanText = `${scheduledPlan} (${scheduledBillingPeriod})`;

  return (
    <>
      <AppAlert
        showIcon
        type="warning"
        message={
          <>
            Your subscription will downgrade to <span className="capitalize! font-semibold">{downgradePlanText}</span>{' '}
            in the next billing cycle on {formattedDate}.
            <span className="text-amber-700 cursor-pointer" onClick={handleOpen}>
              {t('downgrade_cancellation')}
            </span>
          </>
        }
      />
      <DowngradePlanModal
        open={open}
        hideModal={handleClose}
        onDowngradeCancelled={handleDowngradeCancelled}
        isCancelled={false}
        loading={downgradeLoading}
      />
    </>
  );
};
